// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2rXeL","left":"StickyBox_left__36BWu","right":"StickyBox_right__1MggN"};